import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoJobHistories from '@/components/formats/RirekishoParts/AutoJobHistories.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoJobHistoryCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null
  },
  setup(__props: any) {

const descriptionMaxLength = 80



const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  setJobHistories,
  resetJobHistories,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const jobResetVisible = ref(false)

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, setJobHistories, resetJobHistories, addJobHistory, deleteJobHistory, moveJobHistory, activateHistoryItem, jobResetVisible, HistoryItem, AutoJobHistories, NewRirekishoResetDialog }
}

})